// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.carousel-container {
  width: 100%;
  overflow: hidden;
  position: relative;
}

.carousel-scroll-container {
  display: flex;
  gap: 16px;
  overflow-x: auto;
  overflow-y: hidden;
  scroll-behavior: smooth;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE and Edge */
  padding: 0 16px;
  margin: 0 -16px;
}

.carousel-scroll-container::-webkit-scrollbar {
  display: none; /* Chrome, Safari, Opera */
}

/* Ensure consistent card sizing in carousel */
.carousel-scroll-container .product-card {
  flex: 0 0 auto;
  min-width: 235px;
  max-width: 235px;
}

.carousel-scroll-container .add-product-card {
  flex: 0 0 auto;
  min-width: 235px;
  max-width: 235px;
}

/* Responsive adjustments */
@media (max-width: 480px) {
  .carousel-scroll-container {
    padding: 0 12px;
    margin: 0 -12px;
    gap: 12px;
  }
  
  .carousel-scroll-container .product-card {
    min-width: 200px;
    max-width: 200px;
  }
  
  .carousel-scroll-container .add-product-card {
    min-width: 200px;
    max-width: 200px;
  }
}

@media (max-width: 360px) {
  .carousel-scroll-container {
    padding: 0 8px;
    margin: 0 -8px;
    gap: 8px;
  }
  
  .carousel-scroll-container .product-card {
    min-width: 180px;
    max-width: 180px;
  }
  
  .carousel-scroll-container .add-product-card {
    min-width: 180px;
    max-width: 180px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Carousel/Carousel.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;EACvB,iCAAiC;EACjC,qBAAqB,EAAE,YAAY;EACnC,wBAAwB,EAAE,gBAAgB;EAC1C,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,aAAa,EAAE,0BAA0B;AAC3C;;AAEA,8CAA8C;AAC9C;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,2BAA2B;AAC3B;EACE;IACE,eAAe;IACf,eAAe;IACf,SAAS;EACX;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,cAAc;IACd,cAAc;IACd,QAAQ;EACV;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;EAClB;AACF","sourcesContent":[".carousel-container {\n  width: 100%;\n  overflow: hidden;\n  position: relative;\n}\n\n.carousel-scroll-container {\n  display: flex;\n  gap: 16px;\n  overflow-x: auto;\n  overflow-y: hidden;\n  scroll-behavior: smooth;\n  -webkit-overflow-scrolling: touch;\n  scrollbar-width: none; /* Firefox */\n  -ms-overflow-style: none; /* IE and Edge */\n  padding: 0 16px;\n  margin: 0 -16px;\n}\n\n.carousel-scroll-container::-webkit-scrollbar {\n  display: none; /* Chrome, Safari, Opera */\n}\n\n/* Ensure consistent card sizing in carousel */\n.carousel-scroll-container .product-card {\n  flex: 0 0 auto;\n  min-width: 235px;\n  max-width: 235px;\n}\n\n.carousel-scroll-container .add-product-card {\n  flex: 0 0 auto;\n  min-width: 235px;\n  max-width: 235px;\n}\n\n/* Responsive adjustments */\n@media (max-width: 480px) {\n  .carousel-scroll-container {\n    padding: 0 12px;\n    margin: 0 -12px;\n    gap: 12px;\n  }\n  \n  .carousel-scroll-container .product-card {\n    min-width: 200px;\n    max-width: 200px;\n  }\n  \n  .carousel-scroll-container .add-product-card {\n    min-width: 200px;\n    max-width: 200px;\n  }\n}\n\n@media (max-width: 360px) {\n  .carousel-scroll-container {\n    padding: 0 8px;\n    margin: 0 -8px;\n    gap: 8px;\n  }\n  \n  .carousel-scroll-container .product-card {\n    min-width: 180px;\n    max-width: 180px;\n  }\n  \n  .carousel-scroll-container .add-product-card {\n    min-width: 180px;\n    max-width: 180px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
